<template>
  <div class="operation-container">
    <div class="d-flex">
      <div class="title">{{ $l('operation_desc_img') || '操作说明图' }}</div>
      <el-button
        plain
        size="mini"
        class="add--group__button"
        v-if="!disabled"
        @click="openEditGroup"
        >{{ $l('button_text_add_group') || '新建分组' }}</el-button
      >
    </div>
    <div>
      <div class="nodata" v-if="isEmpty">
        <div>
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
      <div v-if="!isEmpty" class="operation-desc">
        <el-collapse v-model="activeNames">
          <div
            v-for="(item, index) in operationData"
            :key="item.evgPackingSchemeGroupCode"
          >
            <el-collapse-item :name="index">
              <template slot="title">
                <div class="operation-item__title_wrapper d-flex">
                  <div class="title">{{ item.groupTitle }}</div>
                  <el-button
                    plain
                    size="mini"
                    class="add--group__button"
                    v-if="!disabled"
                    @click.stop="openEditGroup(item)"
                    >{{ $l('button_text_edit_group') || '编辑分组' }}</el-button
                  >
                </div>
              </template>

              <div class="operation-desc-wrapper">
                <div class="title">
                  {{ $l('operation_overall_requirements') || '整体要求' }}
                </div>
                <div class="desc">
                  {{ item.groupDesc }}
                </div>
                <GroupDescDetail
                  :evgPackingSchemeGroupCode="item.evgPackingSchemeGroupCode"
                  :disabled="disabled"
                ></GroupDescDetail>
              </div>
            </el-collapse-item>
          </div>
        </el-collapse>
      </div>
    </div>
    <EditGroup
      :visible.sync="editGroupOption.visible"
      :evgPackingSchemeCode="evgPackingSchemeCode"
      :evgPackingSchemeGroupCode.sync="
        editGroupOption.evgPackingSchemeGroupCode
      "
      @reload="getData"
    ></EditGroup>
  </div>
</template>
<script>
import EditGroup from './edit-group'
import GroupDescDetail from './group-desc-detail'
export default {
  props: {
    evgPackingSchemeCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  components: { EditGroup, GroupDescDetail },
  data() {
    return {
      operationData: [],
      activeNames: [],
      editGroupOption: {
        visible: false,
        evgPackingSchemeGroupCode: '',
      },
    }
  },
  computed: {
    isEmpty() {
      return !this.operationData.length
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.operationData = []
      this.$api
        .ecomEvgPackingSchemeDescGroupListApi({
          evgPackingSchemeCode: this.evgPackingSchemeCode,
        })
        .then((res) => {
          this.operationData = res.body.data || []
          const len = this.operationData.length
          this.activeNames = []
          for (let i = 0; i < len; i++) {
            this.activeNames.push(i)
          }
        })
    },
    openEditGroup({ evgPackingSchemeGroupCode }) {
      this.editGroupOption.visible = true
      this.editGroupOption.evgPackingSchemeGroupCode =
        evgPackingSchemeGroupCode || ''
    },
  },
}
</script>
<style lang="scss" scoped>
.operation-container {
  margin-top: 20px;
  .title {
    height: 25px;
    line-height: 25px;
    font-weight: 600;
    color: #101010;
    font-size: 18px;
    margin-right: 30px;
  }
  .add--group__button {
    border-radius: 4px !important;
  }
}
.operation-desc {
  margin-top: 20px;
}
.nodata {
  height: calc(100vh - 400px);
  min-height: 250px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.operation-item__title_wrapper {
  justify-content: space-between;
  width: 100%;
  .title {
    height: 23px;
    line-height: 23px;
    color: #101010;
    font-size: 16px;
    font-weight: 600;
  }
  .add--group__button {
    margin-right: 15px;
  }
}
.operation-desc-wrapper {
  margin-top: 15px;
  .title {
    height: 23px;
    line-height: 23px;
    color: #101010;
    font-size: 14px;
    margin-bottom: 2px;
  }
  .desc {
    font-size: 14px;
    color: #101010;
    margin-bottom: 15px;
  }
}
::v-deep {
  .el-collapse {
    border: 0px !important;
  }
  .el-collapse-item__wrap {
    border-bottom: none;
  }
  // .el-collapse-item__header.is-active {
  //   border-bottom-color: #bbbbbb !important;
  // }
  .el-collapse-item__header {
    border-bottom: 1px dashed #bbbbbb;
  }
  .el-collapse-item:last-child {
    margin-bottom: 0px !important;
  }
}
.no-data {
  color: #606266;
  font-size: 13px;
}
</style>
